import {
	Container,
	ContainerPadding,
	Text,
	TokenTextAppearance,
	TextAlignment,
	styled,
	TokenTextColor,
	CTA,
} from '@volkswagen-onehub/components-core';
import { Checkmark } from '@volkswagen-onehub/icons-core';
import React from 'react';

const IconStyled = styled.div`
	color: white;
	width: 64px;
	height: 64px;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
	background-color: #001e50;
`;

const StyledContainer = styled(Container)`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
`;

export const ElClasicoIda2627Participado: React.FC = () => {
	return (
		<Container
			padding={{
				right: ContainerPadding.dynamic0100,
				bottom: ContainerPadding.dynamic0100,
				left: ContainerPadding.dynamic0100,
			}}
			horizontalAlign={'center'}
			wrap={'always'}
		>
			<StyledContainer wrap={'always'} stretchContent>
				<IconStyled>
					<Checkmark />
				</IconStyled>
			</StyledContainer>

			<Container
				wrap={'always'}
				padding={{
					top: ContainerPadding.dynamic0130,
				}}
			>
				<Text appearance={TokenTextAppearance.headline300} textAlign={TextAlignment.center}>
					<Text bold>
						Ya estás participando en el sorteo de 1 entrada VIP doble para el FC Barcelona vs. Real Madrid
					</Text>
					<br />
					¡Mucha suerte!
				</Text>

				<Container
					wrap={'always'}
					padding={{
						top: ContainerPadding.dynamic0130,
					}}
					verticalAlign={'center'}
					horizontalAlign={'center'}
				>
					<Text appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.center}>
						El sorteo se realizará el <Text bold>15 de octubre.</Text> Si eres la persona ganadora nos pondremos en
						contacto contigo.
					</Text>
				</Container>

				<Container
					wrap={'always'}
					padding={{
						top: ContainerPadding.dynamic0100,
						bottom: ContainerPadding.dynamic0100,
					}}
					verticalAlign={'center'}
					horizontalAlign={'center'}
				>
					<Text
						appearance={TokenTextAppearance.copy100}
						color={TokenTextColor.secondary}
						textAlign={TextAlignment.center}
					>
						Consulta las{' '}
						<CTA
							tag="a"
							aria-label="CTA bases legales"
							size="large"
							emphasis="tertiary"
							onClick={() => {
								window.open(
									'https://www.volkswagen.es/idhub/content/dam/onehub_pkw/importers/es/pdf/VW_Bases-Legales-Promocion-CLUBVWLALIGA_ELCLASICO25OCT.pdf',
									'_blank',
								);
							}}
						>
							<Text>bases legales de la promoción</Text>
						</CTA>{' '}
						para más información.
					</Text>
				</Container>
			</Container>
		</Container>
	);
};
